import { Star01 } from '@/assets/icons/scorecard';
import { Flex, Icon } from '@chakra-ui/react';


export const Stars = ({ count = 5 }) => {
  const stars = Array.from({ length: count }, () => count);
  return (
    <Flex gap="12px" cursor="not-allowed">
      {stars?.map((_, index) => (
        <Icon as={Star01} width="24px" height="24px" key={index} />
      ))}
    </Flex>
  );
};
